import React, { useRef } from 'react';
import styles from './Resume.module.scss';
import { v4 as uuidv4 } from 'uuid';
import { useLocation } from 'react-router-dom';

export const SectionWrapper = ({ className = '', ...props }) => {
    return <div {...props} className={`${styles.sectionWrapper} ${className}`} />;
};

export const Section = ({ className = '', ...props }) => {
    return <section {...props} className={`${styles.section} ${className}`} />;
};

export const Title = ({ children, id, rightText, ...props }) => {
    const location = useLocation();
    const highlight = location.hash === '#' + id;

    return (
        <>
            <h2 className={`${styles.sectionTitle}`} {...props} id={id}>
                <span className={highlight ? styles.sectionTitleHighlight : ''}>{children}</span>
                <div className={styles.sectionTitleRight}>{rightText}</div>
            </h2>
            <div className={`${styles.sectionBorder} `} />
        </>
    );
};

export const Entry = ({ children, className = '', articleClassName = '' }) => {
    return (
        <article className={`${styles.sectionEntry} ${articleClassName}`}>
            <div className={`${styles.sectionEntryContent} ${className}`}>{children}</div>
        </article>
    );
};

export const List = ({
    list = [],
    numberOfCols = 1,
    indent = false,
    smallTextOnPrint = false,
    narrow = false,
    compact = false,
    className = ''
}) => {
    const uuid = useRef(uuidv4());
    const classNames = [styles.sectionList];
    if (className) classNames.push(className);
    if (indent) classNames.push(styles.sectionListIndent);
    if (smallTextOnPrint) classNames.push('small-text-on-print');
    if (narrow) classNames.push(styles.sectionListNarrow);
    if (Number(numberOfCols) === 1) classNames.push(styles.sectionListSingle);
    if (compact) classNames.push(styles.sectionListCompact);

    return (
        <ul className={classNames.join(' ')} style={{ '--number-of-cols': numberOfCols }}>
            {list.map((i, index) => (
                <li className={styles.sectionListItem} key={`${uuid}-${index}`}>
                    <span>{i}</span>
                </li>
            ))}
        </ul>
    );
};
